module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/10XT7jn/tc-custom/9781459293168.jpg?1728724770456",
      "alt": "This image is the cover for the book Secret He Must Claim, The Saunderson Legacy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Secret He Must Claim, The Saunderson Legacy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('i', [_vm._v("USA Today")]), _vm._v("–Bestselling Author: An illicit encounter with a mysterious Spaniard leads to unexpected consequences . . . ")]), _c('br'), _c('br'), _vm._v("Heiress Elin Saunderson is instantly seduced by mysterious stranger Cortez. But after their sinful night together she’s left alone . . . and pregnant. A year later, she learns that Cortez is the rightful successor to her adoptive father’s fortune, and penniless Elin finds herself at risk of losing everything—including her son!"), _c('br'), _c('br'), _vm._v("Cortez Ramos is set on claiming the secret Elin kept from him—but Elin proves as protective a mother as she is a torturous temptation. His solution: demand a marriage of convenience, which will legitimize his heir and return Elin to his bed . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Chantelle Shaw\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Chantelle Shaw enjoyed a happy childhood making up stories in her head. Always an avid reader, Chantelle discovered Mills & Boon as a teenager and during the times when her children refused to sleep, she would pace the floor with a baby in one hand and a book in the other! Twenty years later she decided to write one of her own. Writing takes up most of Chantelle’s spare time, but she also enjoys gardening and walking. She doesn't find domestic chores so pleasurable!")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0